exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sizedIcon .vs-icon {\n  color: inherit;\n  font-size: 24px;\n}[dir] .sizedIcon .vs-icon {\n  text-align: center;\n}\n.noOverflow .vs-popup--content {\n  overflow: hidden;\n}\n.popup80 .vs-popup {\n  width: 80% !important;\n}\n.vue_select_drop_size_orgao_emissor_rg_uf_id .vs__dropdown-menu {\n  max-height: 340px;\n}\n.vue_select_drop_size_tenant_state_id .vs__dropdown-menu {\n  max-height: 180px;\n}\n.vue_select_drop_size_tenant_city_id .vs__dropdown-menu {\n  max-height: 180px;\n}\n.vue_select_drop_size_city_cnh_id .vs__dropdown-menu {\n  max-height: 130px;\n}\n\n", ""]);

// exports
